import {
  SessionEnrichmentPlugin,
  AnalyticsEvent,
} from "./SessionEnrichmentPlugin"

export {}

if (import.meta.env.MODE === "production") {
  const sessionEnrichmentPlugin = new SessionEnrichmentPlugin()

  // @ts-ignore
  window.analytics.addSourceMiddleware(sessionEnrichmentPlugin.handleEvent)
  if (!window.ReactNativeWebView) {
    window.analytics.track(AnalyticsEvent.SessionStarted)
  }
  window.analytics.track("AppLoaded")
}
